export const hasAPIError = (reponse) => {
  return !reponse || !reponse.success || reponse.code !== 200
}

export const getAPIData = (response) => response.data;
